import React from 'react';
import { PreferencesForm } from 'features/tasks-forms';
import { SettingsBreadcrumbs } from '../settingsModule';
import { Breadcrumb } from '../../shared/web/layout/Breadcrumbs';
import ShadcnUiSettingsToggle from './ShadcnUiSettingsToggle';
import NewUpdateFormSettingsToggle from './NewUpdateFormSettingsToggle';

export default function PreferencesPage() {
  return (
    <>
      <SettingsBreadcrumbs>
        <Breadcrumb text="Preferences" />
      </SettingsBreadcrumbs>
      <PreferencesForm />
      <NewUpdateFormSettingsToggle />
      <ShadcnUiSettingsToggle />
    </>
  );
}
